const validate = values => {
  const errors = {};
  if (!values.invoiceNo) {
    errors.invoiceNo = 'Favor informar o numero da nota fiscal';
  }
  return errors;
};

export default validate;
